/*----------------------------------------------------------------------------*\
    FORM.ELEMENTS.INPUT-NUMBER
    Number input enhancement, generates toggles for number inputs
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */


/*  Component
\*----------------------------------------------------------------------------*/

oy.form.elements.inputNumber = {
    init: function(){
        if (oy.cutsMustard) {
            this.initElement(document);
        }
    },

    initElement: function($context){
        var self = this;
        var $elements = $context.querySelectorAll('.js--input-number');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupElement($element);
        }
    },

    setupElement: function ($element) {
        $element.classList.add('is-initiated');
        var $input = $element.querySelector('.js--input-number__input');
        var $controlIncrease = $element.querySelector('.js--input-number__control[data-action=increase]');
        var $controlDecrease = $element.querySelector('.js--input-number__control[data-action=decrease]');
        var min = $input.min;
        var max = $input.max;

        /**
         * Increase button
         */
        if ($controlIncrease && !$controlIncrease.getAttribute('onClick')) {
            $controlIncrease.addEventListener('click', function () {
                var currentVal = parseFloat($input.value);
                var newVal = currentVal+1;
                if (typeof max !== 'undefined' && max !== '' && newVal >= max) {
                    newVal = max;
                }
                $input.value = newVal;
            });
        }



        /**
         * Decrease button
         */
        if ($controlDecrease && !$controlDecrease.getAttribute('onClick')) {
            $controlDecrease.addEventListener('click', function () {
                var currentVal = parseFloat($input.value);
                var newVal = currentVal-1;
                if (typeof min !== 'undefined' && min !== '' && newVal <= min) {
                    newVal = min;
                }
                $input.value = newVal;
            });
        }


        /**
         * Visual feedback for keyboard users
         */
        var inputKeyup = function (event) {
            var keyNum = null;
            // Get $source element
            if(window.event) { // IE
                keyNum = event.keyCode;
            } else if(event.which){
                keyNum = event.which;
            }
            if (keyNum === 38) {
                /**
                 * Up key
                 */
                window.requestAnimationFrame(function () {
                    $controlIncrease.classList.add('is-active');
                    setTimeout(function(){
                        window.requestAnimationFrame(function () {
                            $controlIncrease.classList.remove('is-active');
                        });
                    }, 100);
                });
            } else if (keyNum === 40) {
                /**
                 * Down key
                 */
                window.requestAnimationFrame(function () {
                    $controlDecrease.classList.add('is-active');
                    setTimeout(function(){
                        window.requestAnimationFrame(function () {
                            $controlDecrease.classList.remove('is-active');
                        });
                    }, 100);
                });
            }
        };

        $input.onkeydown = inputKeyup;


        /**
         * Manually entered values get converted to min and max
         */
        $input.addEventListener('change', function () {
            var currentVal = parseFloat(this.value);
            if (typeof min !== 'undefined' && min !== '' && currentVal < min) {
                $input.value = min;
            }
            if (typeof max !== 'undefined' && max !== '' && currentVal > max) {
                $input.value = max;
            }
        });
    }
};


/**
 * Fire ALL the things
 */
window.addEventListener('load', function () {
    oy.form.elements.inputNumber.init();
}, false);
